// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.order-table-container {
  --table-bg-color: #fff;
  --table-border-color: var(--cui-border-color, #d8dbe0);
  --table-text-color: var(--cui-body-color, #4f5d73);
  --filter-bg-color: #f8f9fa;
  --filter-border-color: #dee2e6;
  --filter-focus-color: var(--cui-primary, #0d6efd);
  width: 100%;
}
html[data-coreui-theme=dark] .order-table-container {
  --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);
  --table-border-color: var(--cui-dark-border-subtle, #333);
  --table-text-color: var(--cui-body-color, #fff);
  --filter-bg-color: #2a2d3a;
  --filter-border-color: #404552;
  --filter-focus-color: var(--cui-primary, #0d6efd);
}
.order-table-container .table {
  border-color: var(--table-border-color) !important;
  margin-bottom: 0;
  width: 100%;
  table-layout: auto;
}
.order-table-container .table,
.order-table-container .table thead,
.order-table-container .table tbody,
.order-table-container .table tr,
.order-table-container .table th,
.order-table-container .table td {
  border-color: var(--table-border-color) !important;
}
.order-table-container .table:hover,
.order-table-container .table thead:hover,
.order-table-container .table tbody:hover,
.order-table-container .table tr:hover,
.order-table-container .table th:hover,
.order-table-container .table td:hover {
  border-color: var(--table-border-color) !important;
}
.order-table-container .card {
  border-color: var(--table-border-color) !important;
  background-color: var(--table-bg-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  overflow: hidden;
}
.order-table-container .card:hover {
  border-color: var(--table-border-color) !important;
}
.order-table-container .card .card-body {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  padding: 1rem;
  width: 100%;
}
.order-table-container .filter-controls {
  padding: 0;
  margin-bottom: 1rem;
  width: 100%;
}
.order-table-container .table-wrapper {
  width: 100%;
  overflow-x: auto;
}
.order-table-container .order-table {
  margin: 0;
  width: 100%;
}
.order-table-container .order-table {
  width: 100%;
  color: var(--table-text-color);
}
.order-table-container .order-table .table-header-cell {
  border-color: var(--table-border-color) !important;
  font-weight: 600;
  background-color: var(--filter-bg-color);
}
.order-table-container .order-table .table-header-cell.sortable-header {
  cursor: pointer;
  transition: all 0.2s ease;
}
.order-table-container .order-table .table-header-cell.sortable-header:hover {
  background-color: var(--filter-focus-color);
  color: white;
}
.order-table-container .order-table .table-header-cell:hover {
  border-color: var(--table-border-color) !important;
}
.order-table-container .order-table .price-column {
  text-align: right;
  font-weight: 500;
  min-width: 60px;
  width: 60px;
}
.order-table-container .order-table .price-column.total-price {
  font-weight: 700;
  color: var(--cui-success, #198754);
}
.order-table-container .order-table .price-column-header {
  min-width: 60px;
  width: 60px;
  white-space: nowrap;
}
.order-table-container .order-table .quantity-column {
  text-align: center;
  font-weight: 500;
}
.order-table-container .order-table tbody tr {
  border-color: var(--table-border-color) !important;
  transition: all 0.2s ease;
}
.order-table-container .order-table tbody tr:hover {
  border-color: var(--table-border-color) !important;
  background-color: var(--filter-bg-color) !important;
}
.order-table-container .order-table tbody tr td {
  border-color: var(--table-border-color) !important;
}
.order-table-container .order-table tbody tr td:hover {
  border-color: var(--table-border-color) !important;
}
.order-table-container .filter-controls .filter-toggle-btn {
  position: relative;
  transition: all 0.3s ease;
}
.order-table-container .filter-controls .filter-toggle-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.order-table-container .filter-controls .filter-toggle-btn .filter-count-badge {
  background-color: #dc3545;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 0.75rem;
  font-weight: 600;
  min-width: 18px;
  text-align: center;
  display: inline-block;
  animation: pulse 2s infinite;
}
.order-table-container .filter-controls .clear-filters-btn {
  transition: all 0.2s ease;
}
.order-table-container .filter-controls .clear-filters-btn:hover {
  color: #dc3545;
  border-color: #dc3545;
}
.order-table-container .filter-controls .results-info .filtered-info {
  color: var(--cui-secondary);
  font-style: italic;
}
.order-table-container .filter-panel {
  background-color: var(--filter-bg-color);
  border: 1px solid var(--filter-border-color);
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: visible;
}
.order-table-container .filter-panel .filter-field .filter-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--table-text-color);
  margin-bottom: 0.5rem;
}
.order-table-container .filter-panel .filter-field .filter-select {
  background-color: var(--table-bg-color);
  border: 1px solid var(--filter-border-color);
  color: var(--table-text-color);
  border-radius: 0.375rem;
}
.order-table-container .filter-panel .filter-field .filter-select:focus {
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}
.order-table-container .filter-panel .filter-field .filter-input-wrapper {
  position: relative;
}
.order-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--cui-secondary);
  z-index: 5;
  pointer-events: none;
}
.order-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input {
  padding-left: 35px;
  padding-right: 35px;
  border: 1px solid var(--filter-border-color);
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  transition: all 0.2s ease;
}
.order-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input:focus {
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.order-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input::placeholder {
  color: var(--cui-secondary);
  opacity: 0.7;
}
.order-table-container .filter-panel .filter-field .filter-input-wrapper .filter-clear-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  width: 20px;
  height: 20px;
  border: none;
  background: none;
  color: var(--cui-secondary);
  z-index: 5;
}
.order-table-container .filter-panel .filter-field .filter-input-wrapper .filter-clear-btn:hover {
  color: #dc3545;
  background: none;
}
.order-table-container .filter-panel .filter-field .decimal-input-group {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  position: relative;
}
.order-table-container .filter-panel .filter-field .decimal-input-group .whole-input {
  flex: 1 1;
  min-width: 0;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid var(--filter-border-color);
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  text-align: right;
  transition: all 0.2s ease;
}
.order-table-container .filter-panel .filter-field .decimal-input-group .whole-input:focus {
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.order-table-container .filter-panel .filter-field .decimal-input-group .whole-input::placeholder {
  color: var(--cui-secondary);
  opacity: 0.7;
}
.order-table-container .filter-panel .filter-field .decimal-input-group .decimal-separator {
  color: #6c757d;
  font-weight: 600;
  line-height: 1;
}
.order-table-container .filter-panel .filter-field .decimal-input-group .decimal-input {
  width: 64px;
  flex: 0 0 64px;
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid var(--filter-border-color);
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  transition: all 0.2s ease;
}
.order-table-container .filter-panel .filter-field .decimal-input-group .decimal-input:focus {
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.order-table-container .filter-panel .filter-field .decimal-input-group .decimal-input::placeholder {
  color: var(--cui-secondary);
  opacity: 0.7;
}
.order-table-container .filter-panel .filter-field .decimal-input-group .filter-clear-btn-decimal {
  position: absolute;
  right: -25px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  width: 20px;
  height: 20px;
  border: none;
  background: none;
  color: var(--cui-secondary);
  z-index: 5;
}
.order-table-container .filter-panel .filter-field .decimal-input-group .filter-clear-btn-decimal:hover {
  color: #dc3545;
  background: none;
}
.order-table-container .no-data-message .loading-message {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--table-text-color);
}
.order-table-container .no-data-message .no-results-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--cui-secondary);
}
.order-table-container .no-data-message .no-results-message .btn-link {
  color: var(--filter-focus-color);
  text-decoration: none;
}
.order-table-container .no-data-message .no-results-message .btn-link:hover {
  text-decoration: underline;
}
.order-table-container .pagination {
  margin-bottom: 0;
}
.order-table-container .pagination .page-item .page-link {
  color: var(--table-text-color);
  background-color: var(--table-bg-color);
  border-color: var(--filter-border-color);
}
.order-table-container .pagination .page-item .page-link:hover {
  color: var(--filter-focus-color);
  background-color: var(--filter-bg-color);
  border-color: var(--filter-focus-color);
}
.order-table-container .pagination .page-item.active .page-link {
  background-color: var(--filter-focus-color);
  border-color: var(--filter-focus-color);
  color: white;
}
.order-table-container .pagination .page-item.disabled .page-link {
  color: var(--cui-secondary);
  background-color: var(--table-bg-color);
  border-color: var(--filter-border-color);
}
.order-table-container .form-select {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  border-color: var(--filter-border-color);
}
.order-table-container .form-select:focus {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
}
.order-table-container .form-select option {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.order-table-container .cursor-pointer {
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 4px;
}
.order-table-container .cursor-pointer:hover {
  opacity: 0.8;
  transform: scale(1.1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}
@media (max-width: 768px) {
  .order-table-container .filter-panel {
    padding: 1rem;
  }
  .order-table-container .filter-panel .row {
    --bs-gutter-x: 0.5rem;
  }
  .order-table-container .filter-panel .filter-field {
    margin-bottom: 1rem;
  }
  .order-table-container .filter-controls .d-flex {
    flex-direction: column;
    gap: 0.5rem;
    align-items: stretch !important;
  }
  .order-table-container .filter-controls .d-flex .d-flex {
    flex-direction: row;
    align-items: center !important;
  }
  .order-table-container .d-flex.justify-content-between.align-items-center.mt-3 {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch !important;
  }
  .order-table-container .d-flex.justify-content-between.align-items-center.mt-3 .d-flex {
    justify-content: center;
  }
  .order-table-container .d-flex.justify-content-between.align-items-center.mt-3 .text-muted {
    text-align: center;
  }
}
@media (max-width: 576px) {
  .order-table-container .filter-panel .col-lg-3,
  .order-table-container .filter-panel .col-md-4,
  .order-table-container .filter-panel .col-sm-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-table-container .filter-panel .filter-field {
    margin-bottom: 0.75rem;
  }
  .order-table-container .filter-panel .filter-field .filter-label {
    font-size: 0.8rem;
  }
  .order-table-container .filter-panel .filter-field .filter-input {
    font-size: 0.875rem;
  }
  .order-table-container .filter-controls .filter-toggle-btn,
  .order-table-container .filter-controls .clear-filters-btn {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
  }
  .order-table-container .filter-controls .results-info {
    font-size: 0.875rem;
    text-align: center;
  }
  .order-table-container .order-table {
    font-size: 0.875rem;
  }
  .order-table-container .order-table .table-header-cell {
    padding: 0.5rem 0.25rem;
    font-size: 0.8rem;
  }
  .order-table-container .order-table .table td {
    padding: 0.5rem 0.25rem;
    font-size: 0.8rem;
  }
}
html[data-coreui-theme=dark] .order-table-container .card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
html[data-coreui-theme=dark] .order-table-container .filter-panel {
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
}
html[data-coreui-theme=dark] .order-table-container .filter-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.4);
}
html[data-coreui-theme=dark] .order-table-container .cursor-pointer:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
html[data-coreui-theme=dark] .order-table-container .pagination .page-item .page-link:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.order-table-container .text-center {
  text-align: center;
  padding: 1.5rem;
  font-style: italic;
}
.order-table-container .badge-success {
  background-color: var(--cui-success) !important;
  color: #fff;
}
.order-table-container .badge-danger {
  background-color: var(--cui-danger) !important;
  color: #fff;
}
.order-table-container .table.table-hover > tbody > tr:hover {
  border-color: var(--table-border-color) !important;
  color: var(--table-text-color) !important;
}
.order-table-container .table.table-hover > tbody > tr:hover td {
  color: var(--table-text-color) !important;
  background-color: var(--filter-bg-color) !important;
}
.order-table-container .table.table-hover > tbody > tr:hover th {
  color: var(--table-text-color) !important;
}
.order-table-container * {
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}
.order-table-container .expand-cell {
  width: 40px;
  padding: 0.5rem 0.25rem !important;
  text-align: center;
  vertical-align: middle;
}
.order-table-container .expand-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}
.order-table-container .expand-button:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
}
.order-table-container .expand-button .expand-icon {
  transition: transform 0.3s ease;
}
.order-table-container .expanded-row {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
}
html[data-coreui-theme=dark] .order-table-container .expanded-row {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
}
.order-table-container .detail-row {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-top: none !important;
}
html[data-coreui-theme=dark] .order-table-container .detail-row {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);
}
.order-table-container .detail-row .detail-cell {
  padding: 1.5rem !important;
  border-top: 2px solid var(--cui-primary, #0d6efd);
}
.order-table-container .detail-content {
  animation: slideDown 0.3s ease-out;
}
.order-table-container .detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  padding: 1rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--cui-border-color, #d8dbe0);
}
html[data-coreui-theme=dark] .order-table-container .detail-grid {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.order-table-container .detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  border: 1px solid var(--cui-border-color, #d8dbe0);
  transition: all 0.3s ease;
}
.order-table-container .detail-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
html[data-coreui-theme=dark] .order-table-container .detail-item {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);
  border-color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .order-table-container .detail-item:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}
.order-table-container .detail-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--cui-secondary-color, #6c757d);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
html[data-coreui-theme=dark] .order-table-container .detail-label {
  color: var(--cui-secondary-color, #8a93a2);
}
.order-table-container .detail-value {
  font-size: 1rem;
  font-weight: 700;
  color: var(--cui-primary, #0d6efd);
  padding: 0.5rem;
  background: rgba(13, 110, 253, 0.1);
  border-radius: 6px;
  text-align: center;
  border: 1px solid rgba(13, 110, 253, 0.2);
}
html[data-coreui-theme=dark] .order-table-container .detail-value {
  background: rgba(13, 110, 253, 0.2);
  border-color: rgba(13, 110, 253, 0.3);
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .order-table-container .detail-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 0.75rem;
  }
  .order-table-container .detail-item {
    padding: 0.75rem;
  }
  .order-table-container .detail-value {
    font-size: 0.875rem;
    padding: 0.375rem;
  }
}
.order-table-container .detail-row {
  background-color: var(--filter-bg-color);
}
.order-table-container .detail-row .detail-cell {
  padding: 1rem;
  border-top: none;
}
.order-table-container .detail-row .detail-content .detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}
.order-table-container .detail-row .detail-content .detail-grid .detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background-color: var(--table-bg-color);
  border-radius: 0.375rem;
  border: 1px solid var(--table-border-color);
}
.order-table-container .detail-row .detail-content .detail-grid .detail-item .detail-label {
  font-weight: 600;
  color: var(--table-text-color);
  font-size: 0.875rem;
}
.order-table-container .detail-row .detail-content .detail-grid .detail-item .detail-value {
  font-weight: 500;
  color: var(--table-text-color);
  font-size: 0.875rem;
}
.order-table-container .detail-row .detail-content .detail-grid .detail-item .detail-value.total-price-value {
  font-weight: 700;
  color: var(--cui-success, #198754);
  font-size: 1rem;
}

.ops-status-selector {
  position: relative;
  width: 100%;
}
.ops-status-selector .dropdown,
.ops-status-selector .dropup,
.ops-status-selector .dropend,
.ops-status-selector .dropstart,
.ops-status-selector .btn-group {
  display: block;
  width: 100%;
}
.ops-status-selector .dropdown-toggle,
.ops-status-selector .ops-status-toggle {
  width: 100% !important;
  min-height: 31px;
  background-color: var(--table-bg-color);
  border: 1px solid var(--filter-border-color);
  border-radius: 0.375rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--table-text-color);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  position: relative;
  overflow: hidden;
}
.ops-status-selector .dropdown-toggle span:first-child,
.ops-status-selector .ops-status-toggle span:first-child {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 2rem;
}
.ops-status-selector .dropdown-toggle:hover, .ops-status-selector .dropdown-toggle:focus,
.ops-status-selector .ops-status-toggle:hover,
.ops-status-selector .ops-status-toggle:focus {
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
  outline: none;
}
.ops-status-selector .dropdown-toggle.ops-has-selection,
.ops-status-selector .ops-status-toggle.ops-has-selection {
  background-color: var(--table-bg-color);
  border-color: var(--filter-focus-color);
  color: var(--table-text-color);
}
.ops-status-selector .dropdown-toggle.ops-has-selection .ops-selection-count,
.ops-status-selector .ops-status-toggle.ops-has-selection .ops-selection-count {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  background: var(--cui-primary, #0d6efd);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 600;
  min-width: 1.25rem;
  height: 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.35rem;
  border-radius: 999px;
}
.ops-status-selector .ops-status-menu {
  position: absolute;
  top: calc(100% + 0.25rem);
  left: 0;
  z-index: 1060;
  background: var(--cui-body-bg, #fff);
  border: 1px solid var(--cui-border-color, #d8dbe0);
  border-radius: 0.375rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.12);
  padding: 0.5rem;
  margin-top: 0;
  width: 100%;
  min-width: 100%;
  max-height: 320px;
  overflow-y: auto;
  backdrop-filter: blur(10px);
}
.ops-status-selector .ops-status-menu::-webkit-scrollbar {
  width: 6px;
}
.ops-status-selector .ops-status-menu::-webkit-scrollbar-track {
  background: var(--cui-body-bg, #fff);
  border-radius: 6px;
}
.ops-status-selector .ops-status-menu::-webkit-scrollbar-thumb {
  background: var(--cui-border-color, #d8dbe0);
  border-radius: 6px;
}
.ops-status-selector .ops-status-menu .ops-status-option {
  padding: 0.5rem;
  border-radius: 8px;
  margin-bottom: 0.25rem;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
}
.ops-status-selector .ops-status-menu .ops-status-option:hover {
  background: rgba(var(--cui-primary-rgb, 13, 110, 253), 0.06);
  transform: translateX(2px);
}
.ops-status-selector .ops-status-menu .ops-status-option:active {
  transform: translateX(0) scale(0.98);
}
.ops-status-selector .ops-status-menu .ops-status-option .ops-status-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.ops-status-selector .ops-status-menu .ops-status-option .ops-status-checkbox input[type=checkbox] {
  width: 18px;
  height: 18px;
  margin-right: 0.75rem;
  cursor: pointer;
  position: relative;
  appearance: none;
  border: 2px solid var(--cui-border-color, #d8dbe0);
  border-radius: 4px;
  background: var(--cui-body-bg, #fff);
  transition: all 0.2s ease;
}
.ops-status-selector .ops-status-menu .ops-status-option .ops-status-checkbox input[type=checkbox]:checked {
  background: var(--cui-primary, #0d6efd);
  border-color: var(--cui-primary, #0d6efd);
}
.ops-status-selector .ops-status-menu .ops-status-option .ops-status-checkbox input[type=checkbox]:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
}
.ops-status-selector .ops-status-menu .ops-status-option .ops-status-checkbox input[type=checkbox]:hover {
  border-color: var(--cui-primary, #0d6efd);
  box-shadow: 0 0 0 2px rgba(var(--cui-primary-rgb, 13, 110, 253), 0.1);
}
.ops-status-selector .ops-status-menu .ops-status-option .ops-status-checkbox input[type=checkbox]:focus {
  outline: 2px solid var(--cui-primary, #0d6efd);
  outline-offset: 2px;
}
.ops-status-selector .ops-status-menu .ops-status-option .ops-status-checkbox label {
  font-size: 0.875rem;
  color: var(--cui-body-color, #374151);
  font-weight: 500;
  cursor: pointer;
  flex: 1 1;
  line-height: 1.4;
  transition: color 0.2s ease;
}
.ops-status-selector .ops-status-menu .ops-status-option:hover .ops-status-checkbox label {
  color: var(--cui-body-color, #1f2937);
}
html[data-coreui-theme=dark] .ops-status-selector .ops-status-toggle {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  color: var(--cui-body-color, #fff);
}
html[data-coreui-theme=dark] .ops-status-selector .ops-status-toggle:hover {
  box-shadow: 0 4px 12px rgba(var(--cui-primary-rgb, 13, 110, 253), 0.25);
}
html[data-coreui-theme=dark] .ops-status-selector .ops-status-menu {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .ops-status-selector .ops-status-menu .ops-status-option:hover {
  background: rgba(var(--cui-primary-rgb, 13, 110, 253), 0.1);
}
html[data-coreui-theme=dark] .ops-status-selector .ops-status-menu .ops-status-checkbox input[type=checkbox] {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .ops-status-selector .ops-status-menu .ops-status-checkbox label {
  color: var(--cui-body-color, #fff);
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}
@media (max-width: 576px) {
  .ops-status-selector .ops-status-menu {
    min-width: 100%;
    left: 0;
    right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/OrderTable/OrderTable.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,sBAAA;EACA,sDAAA;EACA,kDAAA;EACA,0BAAA;EACA,8BAAA;EACA,iDAAA;EAEA,WAAA;AACF;AACE;EACE,oDAAA;EACA,yDAAA;EACA,+CAAA;EACA,0BAAA;EACA,8BAAA;EACA,iDAAA;AACJ;AAGE;EACE,kDAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AADJ;AAIE;;;;;;EAME,kDAAA;AAFJ;AAII;;;;;;EACE,kDAAA;AAGN;AACE;EACE,kDAAA;EACA,uCAAA;EACA,wCAAA;EACA,WAAA;EACA,gBAAA;AACJ;AACI;EACE,kDAAA;AACN;AAEI;EACE,uCAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;AAAN;AAKE;EACE,UAAA;EACA,mBAAA;EACA,WAAA;AAHJ;AAOE;EACE,WAAA;EACA,gBAAA;AALJ;AAQE;EACE,SAAA;EACA,WAAA;AANJ;AASE;EACE,WAAA;EACA,8BAAA;AAPJ;AASI;EACE,kDAAA;EACA,gBAAA;EACA,wCAAA;AAPN;AASM;EACE,eAAA;EACA,yBAAA;AAPR;AASQ;EACE,2CAAA;EACA,YAAA;AAPV;AAWM;EACE,kDAAA;AATR;AAcI;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAZN;AAcM;EACE,gBAAA;EACA,kCAAA;AAZR;AAgBI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAdN;AAkBI;EACE,kBAAA;EACA,gBAAA;AAhBN;AAmBI;EACE,kDAAA;EACA,yBAAA;AAjBN;AAmBM;EACE,kDAAA;EACA,mDAAA;AAjBR;AAoBM;EACE,kDAAA;AAlBR;AAoBQ;EACE,kDAAA;AAlBV;AA0BI;EACE,kBAAA;EACA,yBAAA;AAxBN;AA0BM;EACE,2BAAA;EACA,yCAAA;AAxBR;AA2BM;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;AAzBR;AA6BI;EACE,yBAAA;AA3BN;AA6BM;EACE,cAAA;EACA,qBAAA;AA3BR;AAgCM;EACE,2BAAA;EACA,kBAAA;AA9BR;AAoCE;EACE,wCAAA;EACA,4CAAA;EACA,kBAAA;EACA,eAAA;EACA,+CAAA;EACA,iBAAA;AAlCJ;AAqCM;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;AAnCR;AAsCM;EACE,uCAAA;EACA,4CAAA;EACA,8BAAA;EACA,uBAAA;AApCR;AAsCQ;EACE,uCAAA;EACA,iDAAA;AApCV;AAwCM;EACE,kBAAA;AAtCR;AAwCQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,2BAAA;EACA,UAAA;EACA,oBAAA;AAtCV;AAyCQ;EACE,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,uCAAA;EACA,8BAAA;EACA,yBAAA;AAvCV;AAyCU;EACE,uCAAA;EACA,iDAAA;EACA,uCAAA;EACA,8BAAA;AAvCZ;AA0CU;EACE,2BAAA;EACA,YAAA;AAxCZ;AA4CQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,UAAA;AA1CV;AA4CU;EACE,cAAA;EACA,gBAAA;AA1CZ;AAgDM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AA9CR;AAgDQ;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,uCAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBAAA;AA9CV;AAgDU;EACE,uCAAA;EACA,iDAAA;EACA,uCAAA;EACA,8BAAA;AA9CZ;AAiDU;EACE,2BAAA;EACA,YAAA;AA/CZ;AAmDQ;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AAjDV;AAoDQ;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,uCAAA;EACA,8BAAA;EACA,yBAAA;AAlDV;AAoDU;EACE,uCAAA;EACA,iDAAA;EACA,uCAAA;EACA,8BAAA;AAlDZ;AAqDU;EACE,2BAAA;EACA,YAAA;AAnDZ;AAuDQ;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,UAAA;AArDV;AAuDU;EACE,cAAA;EACA,gBAAA;AArDZ;AA8DI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AA5DN;AA+DI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AA7DN;AA+DM;EACE,gCAAA;EACA,qBAAA;AA7DR;AA+DQ;EACE,0BAAA;AA7DV;AAoEE;EACE,gBAAA;AAlEJ;AAqEM;EACE,8BAAA;EACA,uCAAA;EACA,wCAAA;AAnER;AAqEQ;EACE,gCAAA;EACA,wCAAA;EACA,uCAAA;AAnEV;AAuEM;EACE,2CAAA;EACA,uCAAA;EACA,YAAA;AArER;AAwEM;EACE,2BAAA;EACA,uCAAA;EACA,wCAAA;AAtER;AA4EE;EACE,uCAAA;EACA,8BAAA;EACA,wCAAA;AA1EJ;AA4EI;EACE,uCAAA;EACA,8BAAA;EACA,uCAAA;EACA,iDAAA;AA1EN;AA6EI;EACE,uCAAA;EACA,8BAAA;AA3EN;AAgFE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AA9EJ;AAgFI;EACE,YAAA;EACA,qBAAA;EACA,yCAAA;AA9EN;AAmFE;EACE;IACE,0CAAA;EAjFJ;EAoFE;IACE,2CAAA;EAlFJ;EAqFE;IACE,wCAAA;EAnFJ;AACF;AAuFE;EACE;IACE,aAAA;EArFJ;EAuFI;IACE,qBAAA;EArFN;EAwFI;IACE,mBAAA;EAtFN;EA2FI;IACE,sBAAA;IACA,WAAA;IACA,+BAAA;EAzFN;EA2FM;IACE,mBAAA;IACA,8BAAA;EAzFR;EA8FE;IACE,sBAAA;IACA,SAAA;IACA,+BAAA;EA5FJ;EA8FI;IACE,uBAAA;EA5FN;EA+FI;IACE,kBAAA;EA7FN;AACF;AAiGE;EAGI;;;IAGE,cAAA;IACA,eAAA;EAjGN;EAoGI;IACE,sBAAA;EAlGN;EAoGM;IACE,iBAAA;EAlGR;EAqGM;IACE,mBAAA;EAnGR;EA0GI;;IAEE,mBAAA;IACA,yBAAA;EAxGN;EA2GI;IACE,mBAAA;IACA,kBAAA;EAzGN;EA6GE;IACE,mBAAA;EA3GJ;EA6GI;IACE,uBAAA;IACA,iBAAA;EA3GN;EA8GI;IACE,uBAAA;IACA,iBAAA;EA5GN;AACF;AAkHI;EACE,wCAAA;AAhHN;AAmHI;EACE,8CAAA;AAjHN;AAqHM;EACE,gDAAA;AAnHR;AAuHI;EACE,wCAAA;AArHN;AAyHM;EACE,wCAAA;AAvHR;AA6HE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AA3HJ;AA8HE;EACE,+CAAA;EACA,WAAA;AA5HJ;AA+HE;EACE,8CAAA;EACA,WAAA;AA7HJ;AAiIE;EACE,kDAAA;EACA,yCAAA;AA/HJ;AAiII;EACE,yCAAA;EACA,mDAAA;AA/HN;AAkII;EACE,yCAAA;AAhIN;AAqIE;EACE,+EAAA;AAnIJ;AAuIE;EACE,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,sBAAA;AArIJ;AAwIE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAtIJ;AAwII;EACE,qBAAA;EACA,8CAAA;AAtIN;AAyII;EACE,+BAAA;AAvIN;AA2IE;EACE,gGAAA;AAzIJ;AA2II;EACE,8FAAA;AAzIN;AA6IE;EACE,6DAAA;EACA,2BAAA;AA3IJ;AA6II;EACE,4GAAA;AA3IN;AA8II;EACE,0BAAA;EACA,iDAAA;AA5IN;AAgJE;EACE,kCAAA;AA9IJ;AAiJE;EACE,aAAA;EACA,2DAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kDAAA;AA/IJ;AAiJI;EACE,uCAAA;EACA,iDAAA;EACA,yCAAA;AA/IN;AAmJE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,6DAAA;EACA,kBAAA;EACA,kDAAA;EACA,yBAAA;AAjJJ;AAmJI;EACE,2BAAA;EACA,wCAAA;AAjJN;AAoJI;EACE,4GAAA;EACA,iDAAA;AAlJN;AAoJM;EACE,wCAAA;AAlJR;AAuJE;EACE,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,yBAAA;EACA,qBAAA;AArJJ;AAuJI;EACE,0CAAA;AArJN;AAyJE;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;AAvJJ;AAyJI;EACE,mCAAA;EACA,qCAAA;AAvJN;AA2JE;EACE;IACE,UAAA;IACA,4BAAA;EAzJJ;EA4JE;IACE,UAAA;IACA,wBAAA;EA1JJ;AACF;AA8JE;EACE;IACE,0BAAA;IACA,SAAA;IACA,gBAAA;EA5JJ;EA+JE;IACE,gBAAA;EA7JJ;EAgKE;IACE,mBAAA;IACA,iBAAA;EA9JJ;AACF;AAkKE;EACE,wCAAA;AAhKJ;AAkKI;EACE,aAAA;EACA,gBAAA;AAhKN;AAoKM;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAlKR;AAoKQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;EACA,uBAAA;EACA,2CAAA;AAlKV;AAoKU;EACE,gBAAA;EACA,8BAAA;EACA,mBAAA;AAlKZ;AAqKU;EACE,gBAAA;EACA,8BAAA;EACA,mBAAA;AAnKZ;AAqKY;EACE,gBAAA;EACA,kCAAA;EACA,eAAA;AAnKd;;AA4KA;EACE,kBAAA;EACA,WAAA;AAzKF;AA4KE;;;;;EAKE,cAAA;EACA,WAAA;AA1KJ;AA8KE;;EAEE,sBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4CAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,wDAAA;EACA,kBAAA;EACA,gBAAA;AA5KJ;AA8KI;;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AA3KN;AA8KI;;;EAEE,uCAAA;EACA,iDAAA;EACA,aAAA;AA3KN;AA8KI;;EACE,uCAAA;EACA,uCAAA;EACA,8BAAA;AA3KN;AA6KM;;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,uCAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AA1KR;AA+KE;EACE,kBAAA;EACA,yBAAA;EACA,OAAA;EACA,aAAA;EACA,oCAAA;EACA,kDAAA;EACA,uBAAA;EACA,6CAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;AA7KJ;AA+KI;EACE,UAAA;AA7KN;AAgLI;EACE,oCAAA;EACA,kBAAA;AA9KN;AAiLI;EACE,4CAAA;EACA,kBAAA;AA/KN;AAmLI;EACE,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAjLN;AAmLM;EACE,4DAAA;EACA,0BAAA;AAjLR;AAoLM;EACE,oCAAA;AAlLR;AAqLM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAnLR;AAqLQ;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;AAnLV;AAqLU;EACE,uCAAA;EACA,yCAAA;AAnLZ;AAqLY;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAnLd;AAuLU;EACE,yCAAA;EACA,qEAAA;AArLZ;AAwLU;EACE,8CAAA;EACA,mBAAA;AAtLZ;AA0LQ;EACE,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,2BAAA;AAxLV;AA4LM;EACE,qCAAA;AA1LR;AAiMI;EACE,uCAAA;EACA,iDAAA;EACA,kCAAA;AA/LN;AAiMM;EACE,uEAAA;AA/LR;AAmMI;EACE,uCAAA;EACA,iDAAA;AAjMN;AAmMM;EACE,2DAAA;AAjMR;AAqMQ;EACE,uCAAA;EACA,iDAAA;AAnMV;AAsMQ;EACE,kCAAA;AApMV;;AA4MA;EAEE;IAEE,UAAA;IACA,mBAAA;EA3MF;EA8MA;IACE,YAAA;IACA,sBAAA;EA5MF;AACF;AAgNA;EACE;IACE,eAAA;IACA,OAAA;IACA,QAAA;EA9MF;AACF","sourcesContent":[".order-table-container {\n  --table-bg-color: #fff;\n  --table-border-color: var(--cui-border-color, #d8dbe0);\n  --table-text-color: var(--cui-body-color, #4f5d73);\n  --filter-bg-color: #f8f9fa;\n  --filter-border-color: #dee2e6;\n  --filter-focus-color: var(--cui-primary, #0d6efd);\n\n  width: 100%;\n\n  html[data-coreui-theme=\"dark\"] & {\n    --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);\n    --table-border-color: var(--cui-dark-border-subtle, #333);\n    --table-text-color: var(--cui-body-color, #fff);\n    --filter-bg-color: #2a2d3a;\n    --filter-border-color: #404552;\n    --filter-focus-color: var(--cui-primary, #0d6efd);\n  }\n\n  // Tablo stilleri\n  .table {\n    border-color: var(--table-border-color) !important;\n    margin-bottom: 0;\n    width: 100%;\n    table-layout: auto;\n  }\n\n  .table,\n  .table thead,\n  .table tbody,\n  .table tr,\n  .table th,\n  .table td {\n    border-color: var(--table-border-color) !important;\n\n    &:hover {\n      border-color: var(--table-border-color) !important;\n    }\n  }\n\n  .card {\n    border-color: var(--table-border-color) !important;\n    background-color: var(--table-bg-color);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    overflow: hidden;\n\n    &:hover {\n      border-color: var(--table-border-color) !important;\n    }\n\n    .card-body {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n      padding: 1rem;\n      width: 100%;\n    }\n  }\n\n  // Filtre kontrollerini ve tabloyu eşit genişlikte tutmak için\n  .filter-controls {\n    padding: 0;\n    margin-bottom: 1rem;\n    width: 100%;\n  }\n\n  // Tablo wrapper - kaydırma için\n  .table-wrapper {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  .order-table {\n    margin: 0;\n    width: 100%;\n  }\n\n  .order-table {\n    width: 100%;\n    color: var(--table-text-color);\n\n    .table-header-cell {\n      border-color: var(--table-border-color) !important;\n      font-weight: 600;\n      background-color: var(--filter-bg-color);\n\n      &.sortable-header {\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background-color: var(--filter-focus-color);\n          color: white;\n        }\n      }\n\n      &:hover {\n        border-color: var(--table-border-color) !important;\n      }\n    }\n\n    // Price column styling\n    .price-column {\n      text-align: right;\n      font-weight: 500;\n      min-width: 60px;\n      width: 60px;\n\n      &.total-price {\n        font-weight: 700;\n        color: var(--cui-success, #198754);\n      }\n    }\n\n    .price-column-header {\n      min-width: 60px;\n      width: 60px;\n      white-space: nowrap;\n    }\n\n    // Quantity column styling\n    .quantity-column {\n      text-align: center;\n      font-weight: 500;\n    }\n\n    tbody tr {\n      border-color: var(--table-border-color) !important;\n      transition: all 0.2s ease;\n\n      &:hover {\n        border-color: var(--table-border-color) !important;\n        background-color: var(--filter-bg-color) !important;\n      }\n\n      td {\n        border-color: var(--table-border-color) !important;\n\n        &:hover {\n          border-color: var(--table-border-color) !important;\n        }\n      }\n    }\n  }\n\n  // Filtre kontrol paneli\n  .filter-controls {\n    .filter-toggle-btn {\n      position: relative;\n      transition: all 0.3s ease;\n\n      &:hover {\n        transform: translateY(-1px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n      }\n\n      .filter-count-badge {\n        background-color: #dc3545;\n        color: white;\n        border-radius: 50%;\n        padding: 2px 6px;\n        font-size: 0.75rem;\n        font-weight: 600;\n        min-width: 18px;\n        text-align: center;\n        display: inline-block;\n        animation: pulse 2s infinite;\n      }\n    }\n\n    .clear-filters-btn {\n      transition: all 0.2s ease;\n\n      &:hover {\n        color: #dc3545;\n        border-color: #dc3545;\n      }\n    }\n\n    .results-info {\n      .filtered-info {\n        color: var(--cui-secondary);\n        font-style: italic;\n      }\n    }\n  }\n\n  // Filtre paneli\n  .filter-panel {\n    background-color: var(--filter-bg-color);\n    border: 1px solid var(--filter-border-color);\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);\n    overflow: visible;\n\n    .filter-field {\n      .filter-label {\n        display: block;\n        font-size: 0.875rem;\n        font-weight: 500;\n        color: var(--table-text-color);\n        margin-bottom: 0.5rem;\n      }\n\n      .filter-select {\n        background-color: var(--table-bg-color);\n        border: 1px solid var(--filter-border-color);\n        color: var(--table-text-color);\n        border-radius: 0.375rem;\n\n        &:focus {\n          border-color: var(--filter-focus-color);\n          box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);\n        }\n      }\n\n      .filter-input-wrapper {\n        position: relative;\n\n        .filter-input-icon {\n          position: absolute;\n          left: 10px;\n          top: 50%;\n          transform: translateY(-50%);\n          color: var(--cui-secondary);\n          z-index: 5;\n          pointer-events: none;\n        }\n\n        .filter-input {\n          padding-left: 35px;\n          padding-right: 35px;\n          border: 1px solid var(--filter-border-color);\n          background-color: var(--table-bg-color);\n          color: var(--table-text-color);\n          transition: all 0.2s ease;\n\n          &:focus {\n            border-color: var(--filter-focus-color);\n            box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n            background-color: var(--table-bg-color);\n            color: var(--table-text-color);\n          }\n\n          &::placeholder {\n            color: var(--cui-secondary);\n            opacity: 0.7;\n          }\n        }\n\n        .filter-clear-btn {\n          position: absolute;\n          right: 5px;\n          top: 50%;\n          transform: translateY(-50%);\n          padding: 0;\n          width: 20px;\n          height: 20px;\n          border: none;\n          background: none;\n          color: var(--cui-secondary);\n          z-index: 5;\n\n          &:hover {\n            color: #dc3545;\n            background: none;\n          }\n        }\n      }\n\n      // Decimal input group (tam sayı + virgül + ondalık)\n      .decimal-input-group {\n        display: flex;\n        align-items: center;\n        gap: 0.35rem;\n        position: relative;\n\n        .whole-input {\n          flex: 1;\n          min-width: 0;\n          padding-left: 10px;\n          padding-right: 10px;\n          border: 1px solid var(--filter-border-color);\n          background-color: var(--table-bg-color);\n          color: var(--table-text-color);\n          text-align: right;\n          transition: all 0.2s ease;\n\n          &:focus {\n            border-color: var(--filter-focus-color);\n            box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n            background-color: var(--table-bg-color);\n            color: var(--table-text-color);\n          }\n\n          &::placeholder {\n            color: var(--cui-secondary);\n            opacity: 0.7;\n          }\n        }\n\n        .decimal-separator {\n          color: #6c757d;\n          font-weight: 600;\n          line-height: 1;\n        }\n\n        .decimal-input {\n          width: 64px;\n          flex: 0 0 64px;\n          text-align: center;\n          padding-left: 10px;\n          padding-right: 10px;\n          border: 1px solid var(--filter-border-color);\n          background-color: var(--table-bg-color);\n          color: var(--table-text-color);\n          transition: all 0.2s ease;\n\n          &:focus {\n            border-color: var(--filter-focus-color);\n            box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n            background-color: var(--table-bg-color);\n            color: var(--table-text-color);\n          }\n\n          &::placeholder {\n            color: var(--cui-secondary);\n            opacity: 0.7;\n          }\n        }\n\n        .filter-clear-btn-decimal {\n          position: absolute;\n          right: -25px;\n          top: 50%;\n          transform: translateY(-50%);\n          padding: 0;\n          width: 20px;\n          height: 20px;\n          border: none;\n          background: none;\n          color: var(--cui-secondary);\n          z-index: 5;\n\n          &:hover {\n            color: #dc3545;\n            background: none;\n          }\n        }\n      }\n    }\n  }\n\n  // Veri bulunamadı mesajları\n  .no-data-message {\n    .loading-message {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--table-text-color);\n    }\n\n    .no-results-message {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      color: var(--cui-secondary);\n\n      .btn-link {\n        color: var(--filter-focus-color);\n        text-decoration: none;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  // Pagination stilleri\n  .pagination {\n    margin-bottom: 0;\n\n    .page-item {\n      .page-link {\n        color: var(--table-text-color);\n        background-color: var(--table-bg-color);\n        border-color: var(--filter-border-color);\n\n        &:hover {\n          color: var(--filter-focus-color);\n          background-color: var(--filter-bg-color);\n          border-color: var(--filter-focus-color);\n        }\n      }\n\n      &.active .page-link {\n        background-color: var(--filter-focus-color);\n        border-color: var(--filter-focus-color);\n        color: white;\n      }\n\n      &.disabled .page-link {\n        color: var(--cui-secondary);\n        background-color: var(--table-bg-color);\n        border-color: var(--filter-border-color);\n      }\n    }\n  }\n\n  // Form select stilleri\n  .form-select {\n    background-color: var(--table-bg-color);\n    color: var(--table-text-color);\n    border-color: var(--filter-border-color);\n\n    &:focus {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n      border-color: var(--filter-focus-color);\n      box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n    }\n\n    option {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n    }\n  }\n\n  // Action butonları\n  .cursor-pointer {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    transition: all 0.2s ease;\n    border-radius: 4px;\n\n    &:hover {\n      opacity: 0.8;\n      transform: scale(1.1);\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    }\n  }\n\n  // Animasyonlar\n  @keyframes pulse {\n    0% {\n      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);\n    }\n\n    70% {\n      box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);\n    }\n\n    100% {\n      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);\n    }\n  }\n\n  // Responsive tasarım\n  @media (max-width: 768px) {\n    .filter-panel {\n      padding: 1rem;\n\n      .row {\n        --bs-gutter-x: 0.5rem;\n      }\n\n      .filter-field {\n        margin-bottom: 1rem;\n      }\n    }\n\n    .filter-controls {\n      .d-flex {\n        flex-direction: column;\n        gap: 0.5rem;\n        align-items: stretch !important;\n\n        .d-flex {\n          flex-direction: row;\n          align-items: center !important;\n        }\n      }\n    }\n\n    .d-flex.justify-content-between.align-items-center.mt-3 {\n      flex-direction: column;\n      gap: 1rem;\n      align-items: stretch !important;\n\n      .d-flex {\n        justify-content: center;\n      }\n\n      .text-muted {\n        text-align: center;\n      }\n    }\n  }\n\n  @media (max-width: 576px) {\n    .filter-panel {\n\n      .col-lg-3,\n      .col-md-4,\n      .col-sm-6 {\n        flex: 0 0 100%;\n        max-width: 100%;\n      }\n\n      .filter-field {\n        margin-bottom: 0.75rem;\n\n        .filter-label {\n          font-size: 0.8rem;\n        }\n\n        .filter-input {\n          font-size: 0.875rem;\n        }\n      }\n    }\n\n    .filter-controls {\n\n      .filter-toggle-btn,\n      .clear-filters-btn {\n        font-size: 0.875rem;\n        padding: 0.375rem 0.75rem;\n      }\n\n      .results-info {\n        font-size: 0.875rem;\n        text-align: center;\n      }\n    }\n\n    .order-table {\n      font-size: 0.875rem;\n\n      .table-header-cell {\n        padding: 0.5rem 0.25rem;\n        font-size: 0.8rem;\n      }\n\n      .table td {\n        padding: 0.5rem 0.25rem;\n        font-size: 0.8rem;\n      }\n    }\n  }\n\n  // Dark mode özel düzenlemeler\n  html[data-coreui-theme=\"dark\"] & {\n    .card {\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    }\n\n    .filter-panel {\n      box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);\n    }\n\n    .filter-input {\n      &:focus {\n        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.4);\n      }\n    }\n\n    .cursor-pointer:hover {\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    }\n\n    .pagination .page-item {\n      .page-link:hover {\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n      }\n    }\n  }\n\n  // Ekstra yardımcı sınıflar\n  .text-center {\n    text-align: center;\n    padding: 1.5rem;\n    font-style: italic;\n  }\n\n  .badge-success {\n    background-color: var(--cui-success) !important;\n    color: #fff;\n  }\n\n  .badge-danger {\n    background-color: var(--cui-danger) !important;\n    color: #fff;\n  }\n\n  // Tablo hover efektleri için özel kurallar\n  .table.table-hover>tbody>tr:hover {\n    border-color: var(--table-border-color) !important;\n    color: var(--table-text-color) !important;\n\n    td {\n      color: var(--table-text-color) !important;\n      background-color: var(--filter-bg-color) !important;\n    }\n\n    th {\n      color: var(--table-text-color) !important;\n    }\n  }\n\n  // Smooth transitions\n  * {\n    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n  }\n\n  // Master-Detail Styles\n  .expand-cell {\n    width: 40px;\n    padding: 0.5rem 0.25rem !important;\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .expand-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border: none;\n\n    &:hover {\n      transform: scale(1.1);\n      box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);\n    }\n\n    .expand-icon {\n      transition: transform 0.3s ease;\n    }\n  }\n\n  .expanded-row {\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n\n    html[data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n    }\n  }\n\n  .detail-row {\n    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n    border-top: none !important;\n\n    html[data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);\n    }\n\n    .detail-cell {\n      padding: 1.5rem !important;\n      border-top: 2px solid var(--cui-primary, #0d6efd);\n    }\n  }\n\n  .detail-content {\n    animation: slideDown 0.3s ease-out;\n  }\n\n  .detail-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 1.5rem;\n    padding: 1rem;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    border: 1px solid var(--cui-border-color, #d8dbe0);\n\n    html[data-coreui-theme=\"dark\"] & {\n      background: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n    }\n  }\n\n  .detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 1rem;\n    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n    border-radius: 8px;\n    border: 1px solid var(--cui-border-color, #d8dbe0);\n    transition: all 0.3s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    }\n\n    html[data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);\n      border-color: var(--cui-dark-border-subtle, #333);\n\n      &:hover {\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n      }\n    }\n  }\n\n  .detail-label {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: var(--cui-secondary-color, #6c757d);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n\n    html[data-coreui-theme=\"dark\"] & {\n      color: var(--cui-secondary-color, #8a93a2);\n    }\n  }\n\n  .detail-value {\n    font-size: 1rem;\n    font-weight: 700;\n    color: var(--cui-primary, #0d6efd);\n    padding: 0.5rem;\n    background: rgba(13, 110, 253, 0.1);\n    border-radius: 6px;\n    text-align: center;\n    border: 1px solid rgba(13, 110, 253, 0.2);\n\n    html[data-coreui-theme=\"dark\"] & {\n      background: rgba(13, 110, 253, 0.2);\n      border-color: rgba(13, 110, 253, 0.3);\n    }\n  }\n\n  @keyframes slideDown {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  // Responsive adjustments for master-detail\n  @media (max-width: 768px) {\n    .detail-grid {\n      grid-template-columns: 1fr;\n      gap: 1rem;\n      padding: 0.75rem;\n    }\n\n    .detail-item {\n      padding: 0.75rem;\n    }\n\n    .detail-value {\n      font-size: 0.875rem;\n      padding: 0.375rem;\n    }\n  }\n\n  // Master-detail row styling\n  .detail-row {\n    background-color: var(--filter-bg-color);\n\n    .detail-cell {\n      padding: 1rem;\n      border-top: none;\n    }\n\n    .detail-content {\n      .detail-grid {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n        gap: 1rem;\n\n        .detail-item {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          padding: 0.5rem;\n          background-color: var(--table-bg-color);\n          border-radius: 0.375rem;\n          border: 1px solid var(--table-border-color);\n\n          .detail-label {\n            font-weight: 600;\n            color: var(--table-text-color);\n            font-size: 0.875rem;\n          }\n\n          .detail-value {\n            font-weight: 500;\n            color: var(--table-text-color);\n            font-size: 0.875rem;\n\n            &.total-price-value {\n              font-weight: 700;\n              color: var(--cui-success, #198754);\n              font-size: 1rem;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.ops-status-selector {\n  position: relative;\n  width: 100%;\n\n  // Ensure dropdown wrappers fill the column width\n  .dropdown,\n  .dropup,\n  .dropend,\n  .dropstart,\n  .btn-group {\n    display: block;\n    width: 100%;\n  }\n\n  // Make the toggle span full width similar to inputs\n  .dropdown-toggle,\n  .ops-status-toggle {\n    width: 100% !important;\n    min-height: 31px;\n    background-color: var(--table-bg-color);\n    border: 1px solid var(--filter-border-color);\n    border-radius: 0.375rem;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    font-weight: 400;\n    color: var(--table-text-color);\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    position: relative;\n    overflow: hidden;\n\n    span:first-child {\n      display: block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      padding-right: 2rem;\n    }\n\n    &:hover,\n    &:focus {\n      border-color: var(--filter-focus-color);\n      box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);\n      outline: none;\n    }\n\n    &.ops-has-selection {\n      background-color: var(--table-bg-color);\n      border-color: var(--filter-focus-color);\n      color: var(--table-text-color);\n\n      .ops-selection-count {\n        position: absolute;\n        top: 50%;\n        right: 0.5rem;\n        transform: translateY(-50%);\n        background: var(--cui-primary, #0d6efd);\n        color: #fff;\n        font-size: 0.7rem;\n        font-weight: 600;\n        min-width: 1.25rem;\n        height: 1.25rem;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        padding: 0 0.35rem;\n        border-radius: 999px;\n      }\n    }\n  }\n\n  .ops-status-menu {\n    position: absolute;\n    top: calc(100% + 0.25rem);\n    left: 0;\n    z-index: 1060;\n    background: var(--cui-body-bg, #fff);\n    border: 1px solid var(--cui-border-color, #d8dbe0);\n    border-radius: 0.375rem;\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.12);\n    padding: 0.5rem;\n    margin-top: 0;\n    width: 100%;\n    min-width: 100%;\n    max-height: 320px;\n    overflow-y: auto;\n    backdrop-filter: blur(10px);\n\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: var(--cui-body-bg, #fff);\n      border-radius: 6px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: var(--cui-border-color, #d8dbe0);\n      border-radius: 6px;\n    }\n\n\n    .ops-status-option {\n      padding: 0.5rem;\n      border-radius: 8px;\n      margin-bottom: 0.25rem;\n      transition: all 0.2s ease;\n      cursor: pointer;\n      position: relative;\n\n      &:hover {\n        background: rgba(var(--cui-primary-rgb, 13, 110, 253), 0.06);\n        transform: translateX(2px);\n      }\n\n      &:active {\n        transform: translateX(0) scale(0.98);\n      }\n\n      .ops-status-checkbox {\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        position: relative;\n\n        input[type=\"checkbox\"] {\n          width: 18px;\n          height: 18px;\n          margin-right: 0.75rem;\n          cursor: pointer;\n          position: relative;\n          appearance: none;\n          border: 2px solid var(--cui-border-color, #d8dbe0);\n          border-radius: 4px;\n          background: var(--cui-body-bg, #fff);\n          transition: all 0.2s ease;\n\n          &:checked {\n            background: var(--cui-primary, #0d6efd);\n            border-color: var(--cui-primary, #0d6efd);\n\n            &::after {\n              content: '✓';\n              position: absolute;\n              top: 50%;\n              left: 50%;\n              transform: translate(-50%, -50%);\n              color: #fff;\n              font-size: 0.75rem;\n              font-weight: 700;\n            }\n          }\n\n          &:hover {\n            border-color: var(--cui-primary, #0d6efd);\n            box-shadow: 0 0 0 2px rgba(var(--cui-primary-rgb, 13, 110, 253), 0.1);\n          }\n\n          &:focus {\n            outline: 2px solid var(--cui-primary, #0d6efd);\n            outline-offset: 2px;\n          }\n        }\n\n        label {\n          font-size: 0.875rem;\n          color: var(--cui-body-color, #374151);\n          font-weight: 500;\n          cursor: pointer;\n          flex: 1;\n          line-height: 1.4;\n          transition: color 0.2s ease;\n        }\n      }\n\n      &:hover .ops-status-checkbox label {\n        color: var(--cui-body-color, #1f2937);\n      }\n    }\n  }\n\n  // Dark mode adaptations\n  html[data-coreui-theme=\"dark\"] & {\n    .ops-status-toggle {\n      background: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n      color: var(--cui-body-color, #fff);\n\n      &:hover {\n        box-shadow: 0 4px 12px rgba(var(--cui-primary-rgb, 13, 110, 253), 0.25);\n      }\n    }\n\n    .ops-status-menu {\n      background: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n\n      .ops-status-option:hover {\n        background: rgba(var(--cui-primary-rgb, 13, 110, 253), 0.1);\n      }\n\n      .ops-status-checkbox {\n        input[type=\"checkbox\"] {\n          background: var(--cui-dark-bg, #212631);\n          border-color: var(--cui-dark-border-subtle, #333);\n        }\n\n        label {\n          color: var(--cui-body-color, #fff);\n        }\n      }\n    }\n  }\n}\n\n// Animation keyframes\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  50% {\n    opacity: 0.8;\n    transform: scale(1.05);\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 576px) {\n  .ops-status-selector .ops-status-menu {\n    min-width: 100%;\n    left: 0;\n    right: 0;\n  }\n}\n\n// Export styles moved to ExportData/ExportData.scss\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
